/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/


import {FETCH_BINARIES_DETAILS_REQUEST, FETCH_BINARIES_DETAILS_SUCCESS, FETCH_BINARIES_DETAILS_FAILURE, UPLOAD_PROGRESS} from './AddNewApkFileCreateReleaseTypes';

const initialState={
    loading:false,
    binary:{},
    error:'',
    uploadProgress:0
}

const applicationBinaryDetailsReducer = (state=initialState, action)=>{
    switch(action.type){
        case FETCH_BINARIES_DETAILS_REQUEST:
            return{
                ...state,
                loading:true,
                uploadProgress:0
                }
            
        case FETCH_BINARIES_DETAILS_SUCCESS:
            return{
                loading:false,
                binary:action.payload,
                error:'',
                uploadProgress:100
            }
        case FETCH_BINARIES_DETAILS_FAILURE:
            return {
                loading:false,
                binary:{},
                error:action.payload,
                uploadProgress:0
            }
        case UPLOAD_PROGRESS:
            return {
                ...state,
                uploadProgress:action.payload
            }
        default:
            return state;
    }
}

export default applicationBinaryDetailsReducer ;